"use client"
import React, { ComponentPropsWithoutRef } from "react"
import { classNames } from "../../utils"
import { Input } from "../Input/Input"

export type InputGroupProps = ComponentPropsWithoutRef<"div">

export const InputGroupInput = Input

const InputGroupBase = ({ children, className, ...rest }: InputGroupProps) => {
  return (
    <div
      className={classNames(
        "*:-mt-px *:rounded-none",
        "*:first:rounded-t-md *:last:rounded-b-md",
        "*:hover:relative *:hover:z-[1]",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

/**
 * Renders a group of inputs stacked vertically.
 */
export const InputGroup = Object.assign(InputGroupBase, {
  Input: InputGroupInput,
})
